import { Component, Input, OnInit } from '@angular/core';
import { LeadRequest } from 'src/app/models/lead-request';
import { LeadResult } from 'src/app/models/lead-result';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-apg-lead-gen-complete',
  templateUrl: './apg-lead-gen-complete.component.html',
  styleUrls: ['./apg-lead-gen-complete.component.scss'],
})
export class ApgLeadGenCompleteComponent implements OnInit {
  @Input() quickQuote: QQQuestionnaireViewModel
  @Input() page: QQQuestionnairePageViewModel;

  result: LeadResult = null;
  loading: boolean;
  error: string;
  contentKey: string;

  constructor(
    private api: ApiService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.contentKey = this.page.settings?.ContentKey ?? "LeadGen.Thankyou";
    this.getResult();
  }

  async getResult() {
    this.loading = true;
    this.result = null;

    const kvp = [...this.quickQuote.answers.entries()]
      .map(x => ({ Key: x[0], Value: x[1] }));

    try {
      const request = new LeadRequest(this.quickQuote.quoteKey, this.analyticsService.getFullPath('lead_gen'), kvp);
      const rsp = await this.api.submitLead(this.quickQuote.questionnaire.name, request);
      this.quickQuote.saveAnswer("Uid", rsp.uid);

      if (rsp.status === "Complete") {
        this.analyticsService.logLeadGen(this.quickQuote, 'lead_gen');
      }
      else if (rsp.status === "Duplicate") {
        this.analyticsService.logDuplicateLeadGen(this.quickQuote, 'lead_gen');
      }

      if (rsp.error) {
        this.error = rsp.error;
      }

    } catch (err) {
    } finally {
      this.loading = false;
    }
  }

}
